"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { ChevronRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PageHeader() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="page-header" className="relative min-h-[45vh] flex items-center bg-gradient-to-br from-[var(--color-logo)] to-secondary overflow-hidden py-20 md:py-32">
      {}
      <div className="absolute inset-0 bg-black/20 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <nav className="flex items-center gap-2 text-primary text-sm font-medium mb-6" aria-label="Breadcrumb">
              <Link to="/" className="hover:text-primary/80 transition-colors">Home</Link>
              <ChevronRight className="size-4 opacity-70" />
              <Link to="#" className="hover:text-primary/80 transition-colors">Industries</Link>
              <ChevronRight className="size-4 opacity-70" />
              <span className="text-primary/70" aria-current="page">Marine & Aerospace</span>
            </nav>

            {}
            <span className="text-primary uppercase tracking-wider text-sm font-bold mb-4 block">
              For Marine & Aerospace OEMs
            </span>

            {}
            <h1 className="font-default text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
              Marine & Aerospace Nameplates and Direct Part Marking
            </h1>

            {}
            <p className="text-white/80 text-lg md:text-xl leading-relaxed mb-8 max-w-2xl font-sans">
              Evermark Industrial Solutions produces MIL-SPEC phenolic nameplates and direct part marking for marine and aerospace OEMs — equipment nameplates, data plates, and serialized 2D data matrix marking built to align with defense and aerospace marking standards when specified. Supply the part and the spec; Evermark marks, verifies when required, and returns.
            </p>

            {}
            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 font-semibold">
                <Link to="/ContactPage">
                  Request a Quote
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="border-primary text-primary hover:bg-primary/10 font-semibold bg-transparent">
                
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative w-full max-w-lg mx-auto lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <div className="relative rounded-lg overflow-hidden shadow-2xl border border-white/10 bg-secondary/50 aspect-[4/3]">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/marine_aerospace_nameplate_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/marine_aerospace_nameplate_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/marine_aerospace_nameplate_hero.png-wvc-sizes" alt="Marine and aerospace nameplate and direct part marking by Evermark Industrial Solutions" className="w-full h-full object-cover" loading="eager" decoding="async" />
              {}
              <div className="absolute top-0 left-0 w-8 h-8 border-t-2 border-l-2 border-primary/50 m-4 pointer-events-none" />
              <div className="absolute bottom-0 right-0 w-8 h-8 border-b-2 border-r-2 border-primary/50 m-4 pointer-events-none" />
            </div>
          </div>

        </div>
      </div>
    </section>;
}